/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


// ST - CUSTOM JS 


function waitForElm(selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}


const fillData = (data) => {
  const resultsContainer = document.querySelector(".collection-results__container");
  const pagination = document.querySelector(".pagination .pagination__inner");
  const resultsSpinner = document.querySelector(".collection-results__spinner");
  const count = document.querySelector(".collection__toolbar .value-picker-wrapper .hidden-phone");
  count.innerHTML = `Display: ${data.countPerPage} per page`;

  resultsContainer.innerHTML = "";

  if (data.products.length === 0) {
    resultsContainer.innerHTML = `
      <div class="empty-state empty-state--tight">
        <p class="empty-state__description">Your criteria did not match any products.</p>
        <div class="empty-state__button-container">
          <button class="empty-state__button button button--primary" data-action="clear-filters" data-url="/collections/eyewear?sort_by=manual">Clear all</button>
        </div>
      </div>
    `;

  } else {
    resultsContainer.innerHTML = `<div class="product-list product-list--collection product-list--with-sidebar"></div>`;
    const productGrid = resultsContainer.querySelector(".product-list--collection");
    const collectionCount = document.querySelector(".collection__showing-count");

    data.products.forEach((product) => {
      const card = document.createElement("div");
      card.className = "product-item product-item--vertical 1/3--tablet-and-up 1/4--desk";
      
      card.innerHTML = `
        <a href="${product.url}" class="product-item__image-wrapper product-item__image-wrapper--with-secondary">
          <div class="aspect-ratio" style="padding-bottom: ${100.0 / product.aspect_ratio}%">
            <img src="${product.image}" alt="${product.title}" width="562" height="556" loading="lazy" sizes="(max-width: 699px) 100vw, 600px" data-media-id="${product.media_id || ''}" class="product-item__primary-image">
            ${product.images && product.images[1] ? `<img src="${product.images[1]}" alt="${product.title}" width="1333" height="1319" loading="lazy" sizes="(max-width: 699px) 100vw, 600px" class="product-item__secondary-image">` : ''}
          </div>
        </a>
        <div class="product-item__info">
          <div class="product-item__info-inner">
            <a href="${product.url}" class="product-item__title text--strong link">${product.title}</a>
            <p class="product-sku">
              SKU: ${product.public_facing_sku}
            </p>
            <div class="product-item__price-list price-list">
              <span class="price">
                ${product.tags.indexOf('custom_price_range') > -1 ? `From&nbsp;${product.custom_starting_price}` : `${product.price}`}
              </span>
            </div>
            <div class="product-metafields">
              ${product.optical_density ? `
                <div class="product-metafields_item">
                  <span class="metafield-title"><b>Optical Density(OD)</b></span>
                  <span class="metafield-content">${product.optical_density}</span>
                </div>
              ` : ''}
              ${product.visible_light_transmission ? `
                <div class="product-metafields_item">
                  <span class="metafield-title"><b>Visible Light Transmission</b></span>
                  <span class="metafield-content">${product.visible_light_transmission}</span>
                </div>
              ` : ''}
              ${product.power_protection ? `
                <div class="product-metafields_item">
                  <span class="metafield-content"><b>Maximum Irradiance</b>: ${product.power_protection}</span>
                </div>
              ` : ''}
            </div>
          </div>
          ${
              product.tags.indexOf('custom_price_range') == -1 ? `
                <form method="post" action="/cart/add" id="product_form_id_${product.id}_template--19394018443494__main" accept-charset="UTF-8" class="product-item__action-list button-stack" enctype="multipart/form-data">
                  <input type="hidden" name="form_type" value="product">
                  <input type="hidden" name="utf8" value="✓">
                  <input type="hidden" name="quantity" value="1">
                  <input type="hidden" name="id" value="${product.variant_id || ''}">
                  <a href="${product.url}" class="product-item__action-button button button--small button--primary">Choose options</a>
                  <button type="button" class="product-item__action-button product-item__action-button--list-view-only button button--small button--ternary hidden-phone" data-action="open-modal" data-secondary-action="open-quick-view" aria-controls="modal-quick-view-template--19394018443494__main" data-product-url="${product.url}">Quick view</button>
                  <input type="hidden" name="product-id" value="${product.id}">
                  <input type="hidden" name="section-id" value="template--19394018443494__main">
                </form>
              ` : `
                <a href="${product.url}" class="product-item__action-button product-item__action-button--link button button--small button--primary">Configure Dimensions and Pricing</a>
              `
          }
        </div>
      `;
      productGrid.appendChild(card);
    });

    pagination.innerHTML = "";
    if (data.pagination.previousPage) {
      const prev = document.createElement("a");
      prev.className = "pagination__prev link";
      prev.innerHTML = `
        <svg focusable="false" class="icon icon--arrow-left " viewBox="0 0 8 12" role="presentation">
          <path stroke="currentColor" stroke-width="2" d="M6 10L2 6l4-4" fill="none" stroke-linecap="square"></path>
        </svg>
        Previous
      `;
      let url = new URL(window.location.href);
      url.searchParams.set('page', data.pagination.previousPage);
      prev.href = url.toString();
      pagination.appendChild(prev);
    }

    let nav = document.createElement("div");
    nav.className = "pagination__nav";

    for (let i = 1; i <= data.pagination.pages; i++) {
      let isCurrent = i === data.pagination.page;
      const pageButton = document.createElement(isCurrent ? "span" : "a");
      pageButton.textContent = i;
      pageButton.className = "pagination__nav-item";
      let url = new URL(window.location.href);
      url.searchParams.set('page', i);

      if (!isCurrent) {
        pageButton.href = url.toString();
      } else {
        pageButton.classList.add("is-active");
      }
      nav.appendChild(pageButton);
    }

    pagination.appendChild(nav);
      

    if (data.pagination.nextPage) {
      const next = document.createElement("a");
      next.className = "pagination__next link";
      next.innerHTML = `Next 
        <svg focusable="false" class="icon icon--arrow-right " viewBox="0 0 8 12" role="presentation">
          <path stroke="currentColor" stroke-width="2" d="M2 2l4 4-4 4" fill="none" stroke-linecap="square"></path>
        </svg>
      `;
      let url = new URL(window.location.href);  
      url.searchParams.set('page', data.pagination.nextPage);
      next.href = url.toString();
      
      pagination.appendChild(next);
    }
    
    pagination.querySelectorAll("a").forEach(link => {
      link.addEventListener("click", (event) => {
        event.preventDefault();
        
        document.dispatchEvent(new CustomEvent("theme:loading:start"));
        const url = new URL(link.href);
        const newParams = new URLSearchParams(url.search);

        // Update browser URL without reload
        history.pushState({}, '', `${window.location.pathname}?${newParams.toString()}`);
        // Fetch new data
        initialSearch(true);
      });
    });

    if (collectionCount) {
      let currentCount = (data.pagination.page - 1) * data.pagination.limit + 1;
      let upperCount = (data.pagination.page - 1) * data.pagination.limit + data.pagination.limit;
      if (upperCount > data.pagination.total) {
        upperCount = data.pagination.total;
      }
      collectionCount.textContent = `Showing ${currentCount} - ${upperCount} of ${data.pagination.total} products`;
    }
  }
  
  resultsContainer.classList.remove("collection-results__container--loading");
  resultsSpinner.classList.remove("collection-results__spinner--visible");
}

window.fillDataCollection = fillData;

const initialSearch = (isScroll=false) => {
  if (window.theme && window.theme.useNativeSearch) {
    // Collection is set to "Use Native Shopify" - the grid is rendered server-side.
    return;
  }
  if (window.location.href.indexOf("/collections/") === -1) {
    console.warn("Not on a collection page, skipping initial search.");
    return;
  }
  const collectionHandle = window.location.pathname.split("/")[2];
  const baseUrl = `https://api.lasersafetyindustries.com/api/search`;
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  const query = params.toString();
  
  let jsonUrl = `${baseUrl}?collection=${collectionHandle}&${query}`;
  let countPerPage = 36;
  if (params.has('per_page')) {
    countPerPage = parseInt(params.get('per_page'), 10);
  }

  jsonUrl += `&limit=${countPerPage}`;
  
  fetch(jsonUrl)
    .then((res) => res.json())
    .then((data) => {
      // Clear and render products
      const resultsContainer = document.querySelector(".collection-results__container");
      const pagination = document.querySelector(".pagination");

      if (!resultsContainer || !pagination) {
        console.warn("Missing .product-grid or .pagination containers");
        waitForElm(".collection-results__container")
          .then(() => {
            console.log("Found .collection-results__container after waiting");
            fillData({...data, countPerPage: countPerPage });
          })
          .catch((err) => {
            console.error("Error waiting for .collection-results__container:", err);
          });

        return;
      }

      fillData({ ...data, countPerPage: countPerPage });
      if (isScroll) {
        document.dispatchEvent(new CustomEvent("theme:loading:end"));
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    })
    .catch((err) => {
      if (isScroll) {
        document.dispatchEvent(new CustomEvent("theme:loading:end"));
      }
      console.error("Failed to fetch collection JSON:", err);
    });
}

function slideToggle(button, element, duration = 500) {
  const elementHeight = element.scrollHeight;
  const svg = button.querySelector('svg');

  if (!element.style.transition) {
    element.style.transition = `height ${duration}ms ease`;
    element.style.overflow = 'hidden';
    element.style.height = `${elementHeight}px`;
    svg.classList.add('open');
  } else {
    element.style.height = '0px';
    element.style.removeProperty("transition");
    svg.classList.remove('open');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const toggleButtons = document.querySelectorAll('.accordion-button');
  toggleButtons.forEach(button => {
    button.addEventListener('click', (event) => {
      const content = event.currentTarget.nextElementSibling;
        slideToggle(button, content, 500);
    });
  });

  const addFilterButtons = document.querySelectorAll('.od-filter-add-row');
  addFilterButtons.forEach(addFilterButton => {
    addFilterButton.addEventListener('click', (event) => {
      event.preventDefault();
      const filterContainer = addFilterButton.closest('.od-filter-group');
      const newFilterRow = filterContainer.querySelector('.od-filter-row--hidden')
      newFilterRow.classList.remove('od-filter-row--hidden');

      const newFilterRowNext = filterContainer.querySelector('.od-filter-row--hidden')
      if (!newFilterRowNext) {
        addFilterButton.classList.add('od-filter-add-row--hidden');
      }
    });
  });

  const removeFilterButtons = document.querySelectorAll('.od-filter-remove-row');
  removeFilterButtons.forEach(button => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      const filterRow = button.closest('.od-filter-row');
      filterRow.classList.add('od-filter-row--hidden'); 
      const filterContainer = button.closest('.od-filter-group');
      const nextFilterRow = filterContainer.querySelector('.od-filter-row--hidden');

      // empty input values
      const odInput = filterRow.querySelector('.od-input');
      const odWaveInput = filterRow.querySelector('.od-wavelength-input');
      if (odInput) {
        odInput.value = '4.0';
      }
      if (odWaveInput) {
        odWaveInput.value = '';
      }
      
      if (!nextFilterRow) {
        const addFilterButton = filterContainer.querySelector('.od-filter-add-row');
        if (addFilterButton) {
          addFilterButton.classList.remove('od-filter-add-row--hidden');
        }
      }
    });
  });

  const filterFormDesktop = document.querySelector('#desktop-filters-form');
  const filterFormMobile = document.querySelector('#mobile-collection-filters-form');

  function submitFilterForm(form) {
    // Get all form inputs
    const inputs = form.querySelectorAll('input, select, textarea');
    const odRows = form.querySelectorAll('.od-filter-row');
    const formData = new FormData();

    // Check each input and only include non-empty values
    inputs.forEach(input => {
      if (input.classList.contains('od-input') || input.classList.contains('od-wavelength-input')) {
        return; // Skip od-inputs
      }
      if (input.type === 'checkbox' && !input.checked) {
        return; // Skip unchecked checkboxes
      }
      formData.append(input.name, input.value);
    });

    odRows.forEach(odRow => {
      let odInput = odRow.querySelector('.od-input');
      let odWaveInput = odRow.querySelector('.od-wavelength-input');

      if (odInput && odInput.value.trim() !== '' && odWaveInput && odWaveInput.value.trim() !== '') {
        // Only append if both od-input and od-wavelength-input have values
        formData.append(odInput.name, odInput.value);
        formData.append(odWaveInput.name, odWaveInput.value);
      }
    });
    // Submit form with only non-empty values
    const params = new URLSearchParams(formData);
    window.location.href = `${window.location.pathname}?${params.toString()}`;
  }

  if (filterFormDesktop) {
    filterFormDesktop.addEventListener('submit', (event) => {
      event.preventDefault();
      submitFilterForm(filterFormDesktop);
    });

    // Listen for checkbox changes
    filterFormDesktop.addEventListener('change', (event) => {
      if (event.target.type === 'checkbox') {
        submitFilterForm(filterFormDesktop);
      }
    });
  }

  if (filterFormMobile) {
    filterFormMobile.addEventListener('submit', (event) => {
      event.preventDefault();
      submitFilterForm(filterFormMobile);
    });

    // Listen for checkbox changes
    filterFormMobile.addEventListener('change', (event) => {
      if (event.target.type === 'checkbox') {
        submitFilterForm(filterFormMobile);
      }
    });
  }

  document.addEventListener('click', function (event) {
    if (event.target.matches('.od-filter-submit')) {
      event.preventDefault();

      const filterForm = event.target.closest('form');
      if (filterForm) {
        submitFilterForm(filterForm);
      }
    }
  });

  let params = new URLSearchParams(window.location.search);
  for (let i = 1; i < 5; i++) {
    let odInput = document.querySelector(`input[name="od_value_${i}"`);
    let odWaveInput = document.querySelector(`input[name="od_wavelength_${i}"`);

    // Check if both odInput and odWaveInput exist
    if (odInput && odWaveInput) {
      let odInputValue = params.get(odInput.name);
      let odWaveInputValue = params.get(odWaveInput.name);

      if (odInputValue) {
        odInput.value = odInputValue;
      }
      if (odWaveInputValue) {
        odWaveInput.value = odWaveInputValue;
      }
    }
  }

  for (let i = 1; i < 5; i++) {
    let odInputMobile = document.querySelector(`#mobile-collection-filters-form input[name="od_value_${i}"]`);
    let odWaveInputMobile = document.querySelector(`#mobile-collection-filters-form input[name="od_wavelength_${i}"]`);

    if (odInputMobile && odWaveInputMobile) {
      let odVal = params.get(`od_value_${i}`);
      let waveVal = params.get(`od_wavelength_${i}`);

      if (odVal) odInputMobile.value = odVal;
      if (waveVal) odWaveInputMobile.value = waveVal;
    }
  }



  initialSearch();
  // INFINITE OPTIONS APP

  "Shoppad.apps.infiniteoptions".split(".").reduce(function(o, x) { if (!o[x]) {o[x] ={};} return o[x] }, window);

  window.Shoppad.apps.infiniteoptions.beforeReady = function(subscribe) {
    subscribe('fieldChange', function(event) {
      setTimeout(() => {
        const priceElIO = document.querySelector(".infiniteoptions-price");
        const priceIO = priceElIO.querySelector(".price-item--regular").textContent.trim();
        
        document.querySelector(".price-list .ST-price").innerHTML = priceIO;
      }, 800);
    });
  };

  window.addEventListener("popstate", () => {
    initialSearch();
  });

  document.addEventListener('click', function (event) {
    if (event.target.matches('[data-action="clear-filters"]')) {
      event.preventDefault();
      const originalUrl = event.target.getAttribute('data-url') || window.location.href;
      const url = new URL(originalUrl, window.location.origin);
      const params = new URLSearchParams(url.search);

      // Remove Shopify filters
      for (const key of [...params.keys()]) {
        if (key.startsWith('filter.') || key === 'q') {
          params.delete(key);
        }
      }

      // Remove OD filters
      for (let i = 1; i <= 4; i++) {
        params.delete(`od_value_${i}`);
        params.delete(`od_wavelength_${i}`);
      }

      // Optional: keep sort_by if desired
      const sortBy = params.get('sort_by');
      const cleanUrl = new URL(window.location.pathname, window.location.origin);
      if (sortBy) {
        cleanUrl.searchParams.set('sort_by', sortBy);
      }

      window.location.href = `${cleanUrl.pathname}?${cleanUrl.searchParams.toString()}`;
    }
  });
});
